var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.layout === 'login' || _vm.$route.meta.layout === 'agreement' || _vm.$route.meta.layout === 'privacy')?_c('router-view'):_c('Layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }